export default __webpack_public_path__ + "media/images/sunflower-patch-fun-card-title-14195b90f6b5ef4374e44577b9edb50e.svg";